<template>
	<div>
		<vx-tooltip :text="getToolTipText()">
			<vs-button id="downloadLabelPdfsButton" class="vs-con-loading__container" color="primary" @click.native="selectedDownloadAddressLabelPdfs"
					   :disabled="isButtonDisabled()">
				<font-awesome-icon :icon="['fas', 'file-pdf']" class="fa-icon"/>
			</vs-button>
		</vx-tooltip>

	</div>
</template>

<script>
import apiClient from "../../services/apiClient";
import {format} from "date-fns";

export default {
	methods: {
		getToolTipText() {
			if (this.$parent.getSelectedOrdersCount() === 0) {
				return 'Er is geen bestelling geselecteerd'
			}

			if (this.$parent.getSelectedOrdersCount() === 1) {
				return 'Download adreslabel pdf';
			}

			return 'Download adreslabel pdf\'s';
		},
		isButtonDisabled() {
			return this.$parent.getSelectedOrdersCount() === 0;
		},
		selectedDownloadAddressLabelPdfs() {
			this.startLoading();

			const selectedOrders = this.$parent.getSelectedOrders();
			const orderIds = [];

			selectedOrders.forEach(order => {
				orderIds.push(order.order.id);
			});

			const params = {
				order_ids: JSON.stringify(orderIds),
			};

			apiClient.get('orders/a6AddressLabel/download', {params, responseType: 'blob'}).then(response => {

				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;

				link.setAttribute('download', 'adreslabels-' + format(new Date(), 'Y-MM-dd_H:mm:ss') + '.pdf');
				document.body.appendChild(link);
				link.click();

				this.stopLoading();
			}).catch(error => {
				console.log(error);

				this.stopLoading();
			})
		},
		startLoading() {
			this.$vs.loading({
				container: '#downloadLabelPdfsButton',
				scale: 0.45
			})
		},
		stopLoading() {
			this.$vs.loading.close('#downloadLabelPdfsButton > .con-vs-loading')
		}
	}
}
</script>
